import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'


import user from './modules/user'
import selectedEmployee from './modules/selectedEmployee'
import jobs from './modules/jobs'
import calls from './modules/calls'
import employers from './modules/employers'
import client from './modules/client'
import vacationLog from './modules/vacationLog'
import browserLang from './modules/browserLang'
import * as getters from './getters'


Vue.use(Vuex)

export const strict = false;
export default new Vuex.Store({
    getters,
    modules: {
        user,
        selectedEmployee,
        jobs,
        calls,
        employers,
        client,
        vacationLog,
        browserLang
    },
    plugins: [createPersistedState(browserLang)],
    strict: process.env.NODE_ENV !== 'production',

})



// WEBPACK FOOTER //
// ./src/store/store.js